<template>
  <div class="comp-container">
    <gamblePopComp boxType="title" :show="true" @close="close">
      <div class="pop-box">
        <div class="region-box" v-for="(regionObj, index) in teamRegionList">
          <div class="region-name">
            <span class="red-black-text">{{ regionObj.name }}</span>
          </div>
          <div class="team-list">
            <div class="scroll-box">
              <div
                class="team-item"
                v-for="(team, index) in regionObj.teamList"
              >
                <img :src="team.icon" />
                <span
                  ><autoTitle runTimeSecondLenght="5" textAlign="center">
                    <span class="red-black-text">{{
                      team.name
                    }}</span></autoTitle
                  ></span
                >
              </div>
              <div class="team-item holder" v-for="(i, index) in 7"></div>
            </div>
          </div>
        </div>
      </div>
    </gamblePopComp>
  </div>
</template>

<script>
import { axios, webSocket, serverApi } from "../../../../common";
import { mapState, mapGetters } from "vuex";
import gamblePopComp from "./../gamble-pop-comp";
import AutoTitle from "../../../../components/autoTitle";

export default {
  name: "showAllTeam",
  props: {
    gameId: {},
  },
  data() {
    return {
      regionList: [
        // {
        //   rid:'a',
        //   name:'a战区',
        // },{
        //   rid:'b',
        //   name:'b战区',
        // }
      ],
      teamList_bak: [
        // ...Array(10)
        //   .fill({})
        //   .map((item, index) => {
        //     return {
        //       tid: "a" + index,
        //       rid: "a",
        //       name: "a" + index,
        //       icon:
        //         "https://nie.res.netease.com/r/pic/20200603/187bb5a3-5d56-4577-b2f7-552f83c10846.png",
        //       region: {
        //         rid: "a",
        //         name: "a战区",
        //       },
        //     };
        //   }),
        // ...Array(20)
        //   .fill({})
        //   .map((item, index) => {
        //     return {
        //       tid: "b" + index,
        //       rid: "b",
        //       name: "b2222222222222222222222" + index,
        //       icon:
        //         "https://nie.res.netease.com/r/pic/20200603/187bb5a3-5d56-4577-b2f7-552f83c10846.png",
        //       region: {
        //         rid: "b",
        //         name: "b战区",
        //       },
        //     };
        //   }),
      ],
    };
  },
  computed: {
    ...mapState(["userData"]),
    ...mapState({
      teamList: (state) => state.gambleObject.teamObj.teamList,
    }),
    ...mapGetters(["gambleActiveCompetition", "nowTs"]),
    teamRegionList() {
      let map = {};
      let list = [];
      // let list = this.regionList.map(region=>{
      //   let obj = {
      //     ...region,
      //     teamList:[]
      //   }
      //   map[region.rid] = obj;
      //   return obj
      // });
      this.teamList.map((team) => {
        if (map[team.region.rid]) {
          map[team.region.rid].teamList.push(team);
        } else {
          map[team.rid] = {
            ...team.region,
            teamList: [team],
          };
          list.push(map[team.rid]);
        }
      });
      return list;
    },
  },
  watch: {
    gambleActiveCompetition() {
      this.getTeamList();
    },
  },
  methods: {
    // async getRegionList(){
    //   if(!this.gameId){
    //     return;
    //   }
    //   let res = await serverApi.get('region',{gid:this.gameId});
    //   if(res.code == 200){
    //     this.regionList = res.data;
    //   }
    // },
    /* async getTeamList() {
      if (!this.gambleActiveCompetition) {
        return;
      }
      let res = await serverApi.get("team", {
        cid: this.gambleActiveCompetition.cid,
      });
      if (res.code == 200) {
        this.teamList_bak = res.data;
      }
    }, */
    close() {
      this.$emit("close");
    },
  },
  components: {
    gamblePopComp,
    AutoTitle,
  },
  mounted() {},
  created() {
    // this.getRegionList();
    // this.getTeamList();
  },
};
</script>

<style lang="scss" scoped>
.red-black-text {
  position: relative;
  background-image: -webkit-linear-gradient(-104deg, #5c1413, #e04445);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  width: auto;
}
.comp-container {
  .pop-box {
    width: 10.9rem;
    height: 5.06rem;
    display: flex;
    // margin-bottom: 0.2rem;

    .region-box {
      flex: 1;
      // background-color: rgba(201, 198, 202, 0.2);
      background-image: linear-gradient(
        180deg,
        rgba(201, 198, 202, 0.2) 50%,
        rgba(201, 198, 202, 0) 100%
      );
      display: flex;
      flex-direction: column;
      // mask: linear-gradient(0deg, transparent 0.1rem, #000 0.7rem);
      &:not(:first-child) {
        margin-left: 0.2rem;
      }

      .region-name {
        height: 0.47rem;
        line-height: 0.47rem;
        background: url(./imgs/region-name-bg.png);
        background-size: auto 100%;
        background-position-x: center;
        text-align: center;
        font-size: 0.26rem;
        font-weight: 600;
        color: #512e00;
      }
      .team-list {
        margin: 0.2rem 0.2rem 0;
        overflow: auto;
        flex: 1;
        mask: linear-gradient(0deg, transparent 0.1rem, #000 0.5rem);
        .scroll-box {
          padding-bottom: 0.1rem;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          padding-bottom: 0.4rem;
        }

        .team-item {
          width: 1.44rem;
          height: 1.56rem;
          margin: 0.1rem;
          position: relative;
          color: #fff;
          text-align: center;
          font-size: 0.22rem;
          &.holder {
            height: 0;
            border: 0;
            margin-top: 0;
            margin-bottom: 0;
          }

          /* border: 0.01rem solid rgba(#fff, 0.2);
          // border: 0.01rem solid #757575;
          background-image: -webkit-linear-gradient(
            bottom,
            rgba(121, 122, 124, 1),
            rgba(67, 68, 72, 0.8) 40%
          ); */
          background-image: url(./imgs/team-item-bg.png);
          background-size: 100% 100%;

          img {
            margin-top: 0.2rem;
            $size: 0.8rem;
            width: $size;
            height: $size;
          }
          > span {
            position: absolute;
            bottom: 0.04rem;
            width: 100%;
            left: 0;
          }
        }
      }
    }
  }
}
</style>
